import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { DialogModel } from '../../../models/dialog-model.model';

@Component({
    selector: 'app-minster-confirm-dialog',
    standalone: true,
    imports: [MatButtonModule, MatDialogModule],
    templateUrl: './minster-confirm-dialog.component.html',
    styleUrl: './minster-confirm-dialog.component.css'
})
export class MinsterConfirmDialogComponent {
    title?: string;
    message?: string;

    constructor(public dialogRef: MatDialogRef<MinsterConfirmDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogModel) {
        // Update view with given values
        this.title = data.title;
        this.message = data.message;
    }

    onConfirm(): void {
        // Close the dialog, return true
        this.dialogRef.close(true);
    }

    onDismiss(): void {
        // Close the dialog, return false
        this.dialogRef.close(false);
    }
}


